import * as React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { keyframes } from '@emotion/core'

const appearAnimation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

const Animation = styled.div`
  display: inline-grid;
  opacity: 0;
  transform: scale(0.8);
  animation: ${appearAnimation};
  animation-timing-function: ease-out;
  animation-duration: 0.25s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-delay: ${props => `${props.animationDelay}s`};
`

// For most use-cases this component will need to be wrapped by `AnimatePresence`
export function GameTileAnimation(props) {
  return <Animation animationDelay={props.delay}>{props.children}</Animation>
}

GameTileAnimation.defaultProps = {
  delay: 0,
}

GameTileAnimation.propTypes = {
  children: PropTypes.node.isRequired,
  delay: PropTypes.number,
}
